import React, { useCallback, useState } from 'react'
import Globals from 'system/Globals'
import styles from './controller-narrative.module.css'
import mstyles from '../narrative/modules/modules.module.css'
import { ReactComponent as CloseButton } from '../assets/icons/close.svg'
import ControllerModalBrowserBrowser from './ControllerModalBrowserBrowser'
import ControllerModalBrowserSlideshow from './ControllerModalBrowserSlideshow'
import ControllerModalBrowserChrome from './ControllerModalBrowserChrome'

function sendUDP(payload) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.controllerHandler) {
        window.webkit.messageHandlers.controllerHandler.postMessage(
            JSON.stringify({ event: 'UDP', command: JSON.stringify(payload) })
        )
    }
}

// Slideshow controls (arrow keys, Present button) are only relevant for
// PowerPoint Online / SharePoint — don't show them for arbitrary websites.
function isPptUrl(url) {
    if (!url) return false
    try {
        const host = new URL(url).hostname.toLowerCase()
        return host.includes('sharepoint.com')
            || host.includes('office.com')
            || host.includes('onedrive.live.com')
            || host.includes('1drv.ms')
    } catch (_) { return false }
}

export default function ControllerModalBrowser({ status, onClose }) {
    const [tappedKey, setTappedKey] = useState(null)

    const onTapChrome = useCallback((type) => {
        setTappedKey(`chrome:${type}`)
        setTimeout(() => setTappedKey(null), 280)
        sendUDP({ type })
    }, [])

    if (status.modalIsLoading) {
        return (
            <div style={s.container}>
                <style>{`@keyframes mbSpin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
                <ControllerModalBrowserChrome
                    url={status.modalUrl || ''}
                    canGoBack={status.modalCanGoBack || false}
                    canGoForward={status.modalCanGoForward || false}
                    isFullscreen={status.modalFullscreen || false}
                    tappedKey={tappedKey}
                    onTap={onTapChrome}
                />
                <div style={s.loadingArea}>
                    <div style={s.spinner} />
                    <div style={s.loadingLabel}>Loading…</div>
                </div>
                <span className={styles.joystickClose}>
                    <div className={mstyles.closeBtnContainer}>
                        <div
                            className="round-btn"
                            onClick={onClose}
                            style={Globals.instance().getThemeStyle(['nav-menu-btn'])}
                        >
                            <CloseButton />
                        </div>
                    </div>
                </span>
            </div>
        )
    }

    if (status.modalInteractionMode === 'slideshow' && isPptUrl(status.modalUrl)) {
        return (
            <ControllerModalBrowserSlideshow
                url={status.modalUrl || ''}
                canGoBack={status.modalCanGoBack || false}
                canGoForward={status.modalCanGoForward || false}
                isFullscreen={status.modalFullscreen || false}
                onClose={onClose}
            />
        )
    }
    return (
        <ControllerModalBrowserBrowser
            items={status.modalItems || []}
            regions={status.modalRegions || []}
            unscoped={status.modalUnscoped || []}
            pageTitle={status.modalPageTitle || ''}
            focusedId={status.modalFocusedId}
            url={status.modalUrl || ''}
            canGoBack={status.modalCanGoBack || false}
            canGoForward={status.modalCanGoForward || false}
            scrollTop={status.modalScrollTop || 0}
            scrollHeight={status.modalScrollHeight || 0}
            clientHeight={status.modalClientHeight || 0}
            debug={status.modalDebug || null}
            isFullscreen={status.modalFullscreen || false}
            dialog={status.modalDialog || null}
            onClose={onClose}
        />
    )
}

const s = {
    container: {
        position: 'fixed', inset: 0, zIndex: 9000,
        background: '#393939',
        display: 'flex', flexDirection: 'column',
        padding: 10,
        boxSizing: 'border-box',
        color: '#fff', fontFamily: 'sans-serif',
        userSelect: 'none',
    },
    loadingArea: {
        flex: 1,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: 14,
    },
    spinner: {
        width: 40, height: 40,
        borderRadius: '50%',
        border: '3px solid rgba(255,255,255,0.12)',
        borderTopColor: 'rgba(255,255,255,0.7)',
        animation: 'mbSpin 0.75s linear infinite',
    },
    loadingLabel: {
        fontSize: 13, color: 'rgba(255,255,255,0.35)',
        letterSpacing: '0.3px',
    },
}
